module.exports = __webpack_public_path__ + "5a3a342440108a22e4ce30f330edeb44.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg-log.jpg
 ** module id = 538
 ** module chunks = 1
 **/